<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{'userRightsManagementDialog.title' | translate}} {{!!userRightsInfo ? ' - ' + userRightsInfo.login : ''}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="dialog-search">
      <div class="btn-group">
        <input type="text" class="form-control" spellcheck="false"
          placeholder="{{'userRightsManagementDialog.info.find_user' | translate}}"
          inputRestricter="^[0-9a-zA-Z!#$%&'*+\-/=?^_`{|}~.@]*$"
          [(ngModel)]="searchUsername"
          (keyup.enter)="searchUser()">
        <button class="btn btn-primary btn-circle" (click)="searchUser()" [disabled]="searchUsername.length < 1">
          <app-svg-icon type="search" size="medium-small"/>
        </button>
        <span id="searchclear" class="mdi mdi-close" [hidden]="searchUsername.length < 1" (click)="searchUsername = ''"></span>
      </div>
    </div>

    @if(!!userRightsInfo){
      <strong class="mt-4 mb-2 d-block">{{'userRightsManagementDialog.mdmGroup' | translate }}</strong>
      <select class="form-control w-50" [(ngModel)]="selectedMdmGroup" [compareWith]="compareMdmGroups" [disabled]="!userRightsInfo">
        <option [ngValue]="null">{{'userRightsManagementDialog.mdmGroup.none' | translate}}</option>
        @for (mdmGroup of allMdmGroups(); track $index) {
          <option [ngValue]="mdmGroup">{{mdmGroup.name}}</option>
        }
      </select>

      <strong class="mt-4 mb-2 d-block">{{'userRightsManagementDialog.info.role' | translate }}</strong>
      <select class="form-control w-50" [(ngModel)]="selectedUserRole" [disabled]="!userRightsInfo">
        @for (role of userRoleNames; track $index) {
          <option [ngValue]="role" [selected]="role === selectedUserRole">{{role}}</option>
        }
      </select>

      @if (additionalUserInfo) {
        <div class="cdc-info">
          <strong class="mt-4 mb-2 d-block">{{ 'userRightsManagementDialog.info.additional_info_from_cdc' | translate }}</strong>
          <ul>
            <li>{{ 'userRightsManagementDialog.info.sales_organization' | translate }}:&nbsp; {{ additionalUserInfo.salesOrganization || '---' }}</li>
            <li>{{ 'userRightsManagementDialog.info.address_number' | translate }}:&nbsp; {{ additionalUserInfo.addressNumber || '---' }}</li>
            <li>{{ 'userRightsManagementDialog.info.role' | translate }}:&nbsp; {{ additionalUserInfo.role || '---' }}</li>
          </ul>
        </div>
      }

      <strong class="mt-4 mb-2 d-block">{{'userRightsManagementDialog.permissions' | translate}}</strong>

      <div class="overflow-a overflow-xh noselect" [style.height.px]="400">
        <table class="table table-striped table-overflow-hidden fixed-layout">
          <tbody>
            @for (userRightOption of userRightOptions(); track $index) {
              <tr>
                <td width="40%" class="text-overflow"
                  tooltip
                [tooltipPosition]="'top'"
                  [tooltipText]="userRightOption.userRight"
                [tooltipMaxWidth]="800"
                  [onlyTruncate]
                (click)="toggleUserRight(userRightOption)">{{userRightOption.userRight}}</td>
            <td width="55%" class="text-overflow"
                tooltip
                [tooltipPosition]="'top'"
                [tooltipText]="userRightOption.description"
                  [tooltipMaxWidth]="800"
                [onlyTruncate]
                  (click)="toggleUserRight(userRightOption)">{{userRightOption.description}}</td>
                <td width="5%">
                  <div class="form-check checkbox ms-2">
                    <input class="form-check-input" type="checkbox" [id]="userRightOption.userRight"
                      [disabled]="isChangeRightsDisabled"
                      [(ngModel)]="userRightOption.isSelected"
                      (change)="setIsUnsavedChangesExist()">
                    <label class="form-check-label" [for]="userRightOption.userRight"></label>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="onCancel()">{{'global.label.close' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" [disabled]="!isUnsavedChangesExist" (click)="onConfirm()">{{'global.label.apply' | translate}}</button>
</div>
